export * from './alert.component';



// WEBPACK FOOTER //
// ./src/app/common/alert/index.ts